import React from 'react';
import PropTypes from 'prop-types';
import { Template, TemplatePlaceholder, Plugin } from '@devexpress/dx-react-core';
import { IconButton, Tooltip } from '@material-ui/core';

const pluginDependencies = [{ name: 'Toolbar' }];

const renderActions = actions => {
    let res = [];
    actions.map((action, index) => {
        res.push(
            <Tooltip key={index} title={action.tooltip} placement="top">
                <IconButton onClick={action.onClick}>
                    <action.icon />
                </IconButton>
            </Tooltip>
        );
    });
    return res;
};

export default function ToolbarActions(props) {
    const { actions } = props;

    return (
        <Plugin name="ToolbarActions" dependencies={pluginDependencies}>
            <Template name="toolbarContent">
                <TemplatePlaceholder />
                {renderActions(actions)}
            </Template>
        </Plugin>
    );
}
ToolbarActions.propTypes = {
    actions: PropTypes.array.isRequired
};



// WEBPACK FOOTER //
// ./data/components/pluginsTable/ToolbarActions.js